import { MemoryRounded } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import colors from "theme/base/colors";

// This is handy: https://convertio.co/png-svg/
export default function AiIcon(
  props: React.ComponentProps<typeof MemoryRounded>,
) {
  return (
    <SvgIcon
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="144.000000pt"
      height="144.000000pt"
      viewBox="0 0 144.000000 144.000000"
      preserveAspectRatio="xMidYMid meet"
      stroke="currentColor"
      {...props}
    >
      <g
        transform="translate(0.000000,144.000000) scale(0.115000,-0.1150000)"
        fill={colors.secondary.main}
        stroke="none"
      >
        <path
          d="M1005 1314 c-28 -151 -90 -213 -255 -255 l-45 -11 73 -19 c131 -33
187 -87 219 -210 9 -38 20 -69 24 -69 4 0 10 19 13 43 9 58 47 136 84 170 30
29 145 77 183 77 32 0 13 17 -28 25 -127 23 -203 95 -234 221 -16 65 -25 73
-34 28z"
        />
        <path
          d="M490 1100 c-12 -12 -20 -33 -20 -55 l0 -35 -71 0 c-67 0 -73 -2 -105
-34 -32 -32 -34 -38 -34 -105 l0 -71 -33 0 c-37 0 -77 -24 -77 -46 0 -26 38
-54 75 -54 l35 0 0 -60 0 -60 -38 0 c-38 0 -72 -23 -72 -47 0 -21 38 -43 73
-43 l37 0 0 -73 c0 -110 37 -147 150 -147 59 0 60 0 60 -28 0 -35 26 -72 50
-72 24 0 50 37 50 72 0 28 1 28 60 28 l60 0 0 -35 c0 -22 8 -43 21 -56 18 -18
23 -19 42 -6 16 10 23 26 25 56 l3 41 61 0 c114 0 158 44 158 159 l0 61 38 0
c43 0 62 14 62 47 0 26 -27 43 -69 43 -31 0 -31 1 -31 51 l0 50 -47 -3 -48 -3
-2 -130 c-2 -72 -5 -140 -8 -152 l-5 -23 -260 0 c-246 0 -260 1 -270 19 -6 12
-10 113 -10 259 0 219 2 240 18 255 15 14 42 17 150 17 l132 0 0 45 0 45 -39
0 c-38 0 -38 1 -44 42 -5 38 -27 68 -49 68 -4 0 -17 -9 -28 -20z"
        />
        <path
          d="M490 778 c-18 -19 -20 -35 -20 -133 0 -157 -2 -155 154 -155 160 0
156 -4 156 158 0 154 2 152 -157 152 -103 0 -114 -2 -133 -22z m200 -138 l0
-60 -60 0 -60 0 0 60 0 60 60 0 60 0 0 -60z"
        />
      </g>
    </SvgIcon>
  );
}
